export default (data) => {
    const { members } = data
    return {
        userIds: members.map(({ id }) => id),
    }
}
